import AgencySaleDetailView from 'features/Agency/components/AgencySaleDetailView';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import useRouter from 'hooks/useRouter';
import PropTypes from 'prop-types';

AgencySaleDetailScreen.propTypes = {
  showSidebar: PropTypes.bool,
};

function AgencySaleDetailScreen({ showSidebar = false }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { agencyId, saleId } = router.query;

  return !showSidebar ? (
    <div className='p-4'>
      <AgencySaleDetailView saleId={saleId} />
    </div>
  ) : (
    <div>
      <KT01BaseLayout isFullScreen={true}>
        <div className="container-fluid px-4 pb-4 mt-4">
          <AgencySaleDetailView saleId={saleId} />
        </div>
      </KT01BaseLayout>
    </div>
  );
}

export default AgencySaleDetailScreen;
